let _initProto;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
console.logLevel = 4;
import css from "./client.css";
import template from "./client.html";
import { ui } from "webcomponent";
import gui from "gui";
import { Icon } from "gui";
import { Label } from "gui";
import { TreeView } from "gui";
import { Contextmenu } from "gui";
import { Tooltip } from "gui";
import Datatable from "datatable";
import ShutdownDialog from "./inc/dialog-shutdown.js";
import ViewOverView from "./inc/view-overview.js";
import ViewLogs from "./inc/view-logs.js";
import EditFermentationButton from "./controls/button-fermentation-edit.js";
import InoculateFermentationButton from "./controls/button-fermentation-inoculate.js";
import BatchAgeLabel from "./controls/label-batchage.js";
import DropDownItemShutDown from "./controls/dropdown-item-shutdown.js";
import TreeviewItemDevice from "./controls/treeview-item-device.js";
import Client from "client";
import moment from "moment";
class MyClient extends Client {
  static {
    [_initProto] = _applyDecs(this, [], [[ui.click("#buttonNew"), 2, "buttonNew_click"], [ui.click("#menuAbout"), 2, "menuAbout_click"], [ui.click("#menuWhatsNew"), 2, "menuWhatsNew_click"], [ui.click("#menuAppearance"), 2, "menuAppearance_click"], [ui.click("#menuLogs"), 2, "menuLogs_click"], [ui.click("#menuLogout"), 2, "menuLogout_click"], [ui.click("#menuShutDown"), 2, "menuShutdown_click"], [ui.click("#menuParameters"), 2, "menuParameters_click"], [ui.click("#menuControlUser"), 2, "menuControlUser_click"]], 0, void 0, Client).e;
  }
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static {
    customElements.define("fulljs-myclient", MyClient);
  }
  async connectedCallback() {
    await super.connectedCallback();

    /* hide console by default */
    this.checkUpdate();
    const resp = await fetch('/api/pc/fermentations', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!resp.ok) throw new Error(`${resp.status}`);
    let fermentations = await resp.json();
    this.onupdatefermentations_handler({
      detail: fermentations
    });
    const es = new EventSource("api/pc/devices-sse");
    es.onmessage = e => {
      let devices = JSON.parse(e.data);
      document.dispatchEvent(new CustomEvent("onupdatedevices", {
        detail: devices
      }));
      application.devices = devices;
    };
    const es2 = new EventSource("api/pc/fermentations-sse");
    es2.onmessage = e => {
      let fermentatsions = JSON.parse(e.data);
      document.dispatchEvent(new CustomEvent("onupdatefermentations", {
        detail: fermentatsions
      }));
      //application.devices = devices;
    };
  }
  constructor() {
    _initProto(super());
    document.addEventListener("onauthenticated", this._onauthenticated_handler.bind(this));
    document.addEventListener("onupdatefermentations", this.onupdatefermentations_handler.bind(this));
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));
  }
  async checkUpdate() {
    if (await server.rcall("RM_upgrade_check")) this.labelUpgradable.style.display = "inline-block";
  }
  async menuUserSettings_click(event) {
    var module = await import("client");
    var SettingsDialog = module.SettingsDialog;
    new SettingsDialog();
  }
  async buttonNew_click() {
    let module = await import("./page/fermentation-new/view-fermentation-new.js");
    let Dialog = module.default;
    let dialog = new Dialog();
    dialog.show();
  }
  async menuAbout_click() {
    let module = await import("./page/about/view-about.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  async menuWhatsNew_click() {
    let module = await import("./page/whatsnew/view-whatsnew.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  async menuAppearance_click() {
    let module = await import("./page/appearance/view-appearance.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  async menuLogs_click() {
    let module = await import("./page/logs/view-logs.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  async menuLogout_click(event) {
    if (await confirm("Are you sure you would like to logout?")) {
      localStorage.removeItem("credentials");
      this.auth_logout();
    }
  }
  async menuShutdown_click() {
    if (await confirm("Are you sure you would like to shutdown?")) {
      const res = await fetch('/api/pc/poweroff');
      if (!res.ok) {
        error('Shutdown request failed');
        throw new Error('Shutdown request failed');
      }
    }
  }
  async menuParameters_click() {
    let module = await import("./page/parameters/view-parameters.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  async menuControlUser_click(event) {
    let module = await import("./page/scripts/view-scripts.js");
    let Page = module.default;
    let page = this.tab.appendChild(new Page({
      closable: true
    }));
    page.select();
  }
  menuUsermanager_click(event) {
    import("dialog").then(function (module) {
      new module.UsermanagerDialog();
    }).catch(function (result) {
      error(result);
    });
  }
  menuEmailConfig_click(event) {
    import("./dialogs/dialog-config-email.js").then(function (module) {
      new module.default();
    }).catch(function (result) {
      error(result);
    });
  }
  menuConsole_click(event) {
    this.padderConsole.style.visibility = this.padderConsole.style.visibility == "hidden" ? "visible" : "hidden";
    this.padderConsole.style.height = this.padderConsole.style.height == "0em" ? "30em" : "0em";
    this.menuConsole.icon.style.visibility = this.padderConsole.style.visibility;
  }
  menuNavigation_click(event) {
    this.padderNavigation.style.display = this.padderNavigation.style.display == "none" ? "" : "none";
    this.menuNavigation.icon.style.visibility = this.padderNavigation.style.display == "none" ? "hidden" : "visible";
  }
  buttonCalculate_click(event) {
    import("./dialogs/dialog-offgascalculation.js").then(function (module) {
      new module.default();
    }).catch(function (result) {
      error(result);
    });
  }
  buttonImage_click(event) {
    import("./dialogs/dialog-image.js").then(function (module) {
      new module.default();
    }).catch(function (result) {
      error(result);
    });
  }
  buttonViewProjectbrowser_click(event) {
    this.viewProjectbrowser.style.display = "";
    this.viewControls.style.display = "none";
    this.viewProperties.style.display = "none";
  }
  buttonViewControls_click(event) {
    this.viewProjectbrowser.style.display = "none";
    this.viewControls.style.display = "";
    this.viewProperties.style.display = "none";
  }
  buttonViewProperties_click(event) {
    this.viewProjectbrowser.style.display = "none";
    this.viewControls.style.display = "none";
    this.viewProperties.style.display = "";
  }
  RM_alert(notification, message) {
    alert(message);
  }
  RM_updateServiceStatus(notification, processList) {
    window.dispatchEvent(new CustomEvent("onservicestatuschange", {
      detail: {
        host: "localhost",
        processList: processList
      }
    }));
  }
  RM_updateSensorsValues(notification, sensors) {
    window.dispatchEvent(new CustomEvent("onupdatesensorsvalues", {
      detail: sensors
    }));
  }
  RM_updateDevices(notification, devices) {
    document.dispatchEvent(new CustomEvent("onupdatedevices", {
      detail: devices
    }));
    application.devices = devices;
  }
  RM_updateFermentations(notification, fermentations) {
    document.dispatchEvent(new CustomEvent("onupdatefermentations", {
      detail: fermentations
    }));
  }
  RM_log(notification, log) {
    document.dispatchEvent(new CustomEvent("onlog", {
      detail: log
    }));
  }
  RM_alert(notification, message) {
    alert(message);
  }
  RM_shutdown(notification, message) {
    if (!this.shutdownDialog) this.shutdownDialog = new ShutdownDialog();
    this.shutdownDialog.message = message;
  }
  RM_addState(notification, state) {
    this.classList.add(state);
  }
  RM_removeState(notification, state) {
    this.classList.remove(state);
  }
  onupdatefermentations_handler(event) {
    var fermentations = event.detail;
    while (this._treeviewFermentations.children.length != 2) this._treeviewFermentations.children[this._treeviewFermentations.children.length - 1].remove();
    for (var fermentation in fermentations) {
      var item = this._treeviewFermentations.appendChild(new gui.treeview.Item({
        icon: new gui.icon({
          context: "mimetypes",
          size: 16,
          iconname: "text-x-generic"
        }),
        label: new gui.label({
          value: fermentations[fermentation].id
        })
      }));
      if (fermentations[fermentation].running) {
        item.appendChild(new gui.icon({
          context: "actions",
          size: 16,
          iconname: "flag-green",
          slot: "head",
          style: "order: 4"
        }));
      }
      var contextmenu = item.appendChild(new Contextmenu());
      contextmenu.appendChild(new Contextmenu.Item({
        label: new Label({
          value: "Edit fermentation"
        }),
        icon: new gui.icon({
          context: "actions",
          size: 16,
          iconname: "document-edit"
        }),
        onclick: async function (id, event) {
          let module = await import("./page/fermentation-new/view-fermentation-new.js");
          let Dialog = module.default;
          let dialog = new Dialog({
            fid: id
          });
          dialog.show();
        }.bind(this, fermentations[fermentation].id)
      }));
      contextmenu.appendChild(new Contextmenu.Item({
        label: new Label({
          value: "Inoculate"
        }),
        icon: new gui.icon({
          context: "actions",
          size: 16,
          iconname: "gtk-color-picker"
        }),
        onclick: async function (id, event) {
          if (!(await confirm("Are you sure you wish to inoculate?"))) return;
          let resp = await fetch(`/api/pc/fermentations/${id}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!resp.ok) throw new Error(`${resp.status}`);
          let fermentation = await resp.json();
          fermentation.inoculationDate = new Date();
          resp = await fetch(`/api/pc/fermentations/${id}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(fermentation)
          });
          if (!resp.ok) throw new Error(`${resp.status}`);
        }.bind(this, fermentations[fermentation].id)
      }));
      contextmenu.appendChild(new Contextmenu.Item({
        label: new Label({
          value: "Remove fermentation"
        }),
        icon: new gui.icon({
          context: "actions",
          size: 16,
          iconname: "archive-remove"
        }),
        onclick: async function (id, event) {
          if (await confirm("Are you sure you would like to delete this fermentation?")) {
            try {
              const resp = await fetch(`/api/pc/fermentations/${id}`, {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
              if (!resp.ok) {
                throw new Error(`${await resp.text()}`);
              }
            } catch (e) {
              error(e.message);
            }
          }
        }.bind(this, fermentations[fermentation].id)
      }));
      item.addEventListener("click", function (id, event) {
        import("./page/fermentation-plot/view-fermentation-plot.js").then(function (module) {
          this.tab.appendChild(new module.default(id)).select();
        }.bind(this)).catch(function (result) {
          error(result);
        }.bind(this));
      }.bind(this, fermentations[fermentation].id));
    }
  }
  onupdatedevices_handler(event) {
    //TODO: now assoc array, should be simple array with objects
    var devices = event.detail;

    //disconnect handle
    let uids = Object.entries(devices).map(([key, value]) => value.usbProductName + "_" + value.usbSerialNumber);
    for (let item of Array.from(this._treeviewSensors.querySelectorAll("fulljs-treeview-item"))) {
      if (!uids.includes(item.id)) item.remove();
    }

    //connect handle
    for (let device in devices) {
      if (!devices.hasOwnProperty(device)) continue;
      if (!devices[device].usbProductName || !devices[device].usbSerialNumber) {
        console.warn(`device cannot be identified: ${device}`);
        continue;
      }
      let uid = devices[device].usbProductName + "_" + devices[device].usbSerialNumber;
      if (!this._treeviewSensors[uid]) {
        let item = this._treeviewSensors.appendChild(new TreeviewItemDevice({
          id: uid,
          name: device,
          label: new Label({
            value: device
          }),
          onclick: async function (device) {
            let dir = device.usbProductName.toLowerCase().replace(/ /g, '_');
            var module = await import(`./peripherals/${dir}/dialog-config.js`);
            var Dialog = module.default;
            new Dialog({
              name: device.name,
              endpoint: device.usbProductName + "_" + device.usbSerialNumber
            });
          }.bind(this, devices[device])
        }, devices[device]));
        /*
        item.appendChild( new Tooltip({
          value: `Name: ${device}</br></br>usbProductName: ${devices[device].usbProductName}</br>usbSerialNumber: ${devices[device].usbSerialNumber}</br>ErrorFlags: ${devices[device].errorFlags}`
        }) );        
        */
      }
    }
    return;
    this.treeviewItemThermostat.label.style.color = devices.thermostat.status == "Ok" ? "" : "red";
    this.treeviewItemSteering.label.style.color = devices.stirring.status == "Ok" ? "" : "red";

    //if (devices.ups.status == "Ok") {
    if (devices.ups) {
      this.treeviewItemUPS.label.style.color = "";
      var mode = devices.ups.power_mode == 1 ? "-charging" : "";
      var percentage = devices.ups.battery_percentage;
      percentage = Math.max(0, percentage);
      percentage = Math.min(100, percentage);
      percentage = Math.round(percentage / 20) * 20;
      if (percentage == 100 && mode == "-charging") percentage = "";else if (percentage == 100 && mode == "") percentage = "-100";else if (percentage <= 20) percentage = "-low";else percentage = "-0" + percentage;
      var iconname = `battery${mode}${percentage}`;
      this.treeviewItemUPS.icon.iconname = iconname;
    } /* else {
       this.treeviewItemUPS.icon.iconname = "battery-missing";
       this.treeviewItemUPS.label.style.color = "red";
      }*/

    //console.log(document.documentElement.style.cssText);

    for (let style of document.documentElement.style.cssText.split(";")) {
      var [name, value] = style.split(":");
      if (!name.startsWith("--device")) continue;
      document.documentElement.style.removeProperty(name);
    }
    for (let device in devices) {
      document.documentElement.style.setProperty(`--device-${device}`, "block");
    }
  }
  /* TODO: name conflict with parent class */
  async _onauthenticated_handler(event) {
    console.log("authenticated");
    /*
    var fermentations = await server.rcall("RM_fermentation_getFermentations");
    document.dispatchEvent( new CustomEvent("onupdatefermentations", {
      detail: fermentations
    }) );
    */
  }
}
new MyClient();